<style>
    .tiles-container * {
        margin: 0;
    }
</style>
<div class="tiles-container" [style.width.mm]="width" [style.height]="height > 0 ? (height +'mm') : 'auto'" style="
 border: 1px solid #eee; border-radius: 4px; overflow: hidden; background: #ffffff;">
    <div style="
       font-family: Tahoma, serif;
       line-height: 1.2;
        box-sizing: border-box;
        color: #000;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        font-weight: normal;
        font-size: 10pt;
        padding: 2mm;
        page-break-after: always;
        justify-content: flex-start;
        align-items: stretch;
        align-content: flex-start">
        <div *ngFor="let tile of layout; let i = index" [style.width]="tile.size" class="tile"
             style="padding-bottom: 1mm; margin-bottom: 1mm; flex-grow:1; flex-shrink: 0"
             [style.border-bottom]="tile.border_b ? '1px solid #000' : 'none'"
             [style.border-right]="tile.border_r ? '1px solid #000' : 'none'"
             [style.border-top]="tile.border_t ? '1px solid #000' : 'none'"
             [style.border-left]="tile.border_l ? '1px solid #000' : 'none'">

            <div class="tile-content"
                 style="display: flex;
                flex-direction: column;
                height: 100%;
                max-height: 100%;
                flex-wrap: nowrap; word-break: break-all;"
                 [style.justify-content]="setVerticalAlign(tile.align_v)"
                 [style.align-items]="setHorizontalAlign(tile.align_h)">
                <div *ngFor="let element of tile.content">
                    <div *ngIf="element.tag === 'free_text' && data.free_text"
                         [innerHTML]="trustHtml(data.free_text)"></div>

                    <div *ngIf="element.tag === 'partner_logo' && data.partner_logo">
                        <img [src]="data.partner_logo" alt=""
                             style="max-width: 100%; height:auto; width: auto; max-height: 50px">
                    </div>

                    <div *ngIf="element.tag === 'partner_name' && data.partner_name">
                        {{ data.partner_name }}
                    </div>

                    <div *ngIf="element.tag === 'order_ref' && data.order_ref">
                        Ref: <b>{{ data.order_ref }}</b>
                    </div>

                    <div *ngIf="element.tag === 'order_ref_bc' && data.order_ref">
                        <common-barcode
                                [bcValue]="data.order_ref"
                                [bcDisplayValue]="false"
                                [bcMarginTop]="1"
                                [bcMarginLeft]="1"
                                [bcMarginRight]="1"
                                [bcMarginBottom]="1"
                                [bcWidth]="1"
                                [bcHeight]="20"></common-barcode>
                    </div>

                    <div *ngIf="element.tag === 'item' && data.item">
                        Item: <b>{{ data.item }}</b>
                    </div>

                    <div *ngIf="element.tag === 'item_bc' && data.item">
                        <common-barcode
                                [bcValue]="data.item"
                                [bcDisplayValue]="false"
                                [bcMarginTop]="1"
                                [bcMarginLeft]="1"
                                [bcMarginRight]="1"
                                [bcMarginBottom]="1"
                                [bcWidth]="1"
                                [bcHeight]="20"></common-barcode>
                    </div>

                    <div *ngIf="element.tag === 'item_qty' && data.item_qty">
                        Qty: <b>{{ data.item_qty }}</b>
                    </div>

                    <div *ngIf="element.tag === 'item_qty_bc' && data.item_qty">
                        <common-barcode
                                [bcValue]="data.item_qty"
                                [bcDisplayValue]="false"
                                [bcMarginTop]="1"
                                [bcMarginLeft]="1"
                                [bcMarginRight]="1"
                                [bcMarginBottom]="1"
                                [bcWidth]="1"
                                [bcHeight]="20"></common-barcode>
                    </div>

                    <div *ngIf="element.tag === 'item_description' && data.item_description">
                        {{ data.item_description }}
                    </div>

                    <div *ngIf="element.tag === 'serial' && data.serial">
                        SN: <b>{{ data.serial }}</b>
                    </div>

                    <div *ngIf="element.tag === 'serial_bc' && data.serial">
                        <common-barcode
                                [bcValue]="data.serial"
                                [bcDisplayValue]="false"
                                [bcMarginTop]="1"
                                [bcMarginLeft]="1"
                                [bcMarginRight]="1"
                                [bcMarginBottom]="1"
                                [bcWidth]="1"
                                [bcHeight]="20"></common-barcode>
                    </div>

                    <div *ngIf="element.tag === 'batch' && data.batch">
                        Batch: <b>{{ data.batch }}</b>
                    </div>

                    <div *ngIf="element.tag === 'batch_bc' && data.batch">
                        <common-barcode
                                [bcValue]="data.batch"
                                [bcDisplayValue]="false"
                                [bcMarginTop]="1"
                                [bcMarginLeft]="1"
                                [bcMarginRight]="1"
                                [bcMarginBottom]="1"
                                [bcWidth]="1"
                                [bcHeight]="20"></common-barcode>
                    </div>

                    <div *ngIf="element.tag === 'rev' && data.rev">
                        Rev: <b>{{ data.rev }}</b>
                    </div>

                    <div *ngIf="element.tag === 'rev_bc' && data.rev">
                        <common-barcode
                                [bcValue]="data.rev"
                                [bcDisplayValue]="false"
                                [bcMarginTop]="1"
                                [bcMarginLeft]="1"
                                [bcMarginRight]="1"
                                [bcMarginBottom]="1"
                                [bcWidth]="1"
                                [bcHeight]="20"></common-barcode>
                    </div>


                    <div *ngIf="element.tag === 'lot' && data.lot">
                        Lot: <b>{{ data.lot }}</b>
                    </div>

                    <div *ngIf="element.tag === 'lot_bc' && data.lot">
                        <common-barcode
                                [bcValue]="data.lot"
                                [bcDisplayValue]="false"
                                [bcMarginTop]="1"
                                [bcMarginLeft]="1"
                                [bcMarginRight]="1"
                                [bcMarginBottom]="1"
                                [bcWidth]="1"
                                [bcHeight]="20"></common-barcode>
                    </div>


                    <div *ngIf="element.tag === 'configurations' && data.configurations">
                        Conf: <b>{{ data.configurations }}</b>
                    </div>

                    <div *ngIf="element.tag === 'configurations_bc' && data.configurations">
                        <common-barcode
                                [bcValue]="data.configurations"
                                [bcDisplayValue]="false"
                                [bcMarginTop]="1"
                                [bcMarginLeft]="1"
                                [bcMarginRight]="1"
                                [bcMarginBottom]="1"
                                [bcWidth]="1"
                                [bcHeight]="20"></common-barcode>
                    </div>

                    <div *ngIf="element.tag === 'box_ref' && data.box_ref">
                        Box: <b>{{ data.box_ref }}</b>
                    </div>

                    <div *ngIf="element.tag === 'box_ref_bc' && data.box_ref">
                        <common-barcode
                                [bcValue]="data.box_ref"
                                [bcDisplayValue]="false"
                                [bcMarginTop]="1"
                                [bcMarginLeft]="1"
                                [bcMarginRight]="1"
                                [bcMarginBottom]="1"
                                [bcWidth]="1"
                                [bcHeight]="20"></common-barcode>
                    </div>

                    <div *ngIf="element.tag === 'pallet_ref' && data.pallet_ref">
                        Pallet/OB: <b>{{ data.pallet_ref }}</b>
                    </div>

                    <div *ngIf="element.tag === 'pallet_ref_bc' && data.pallet_ref">
                        <common-barcode
                                [bcValue]="data.pallet_ref"
                                [bcDisplayValue]="false"
                                [bcMarginTop]="1"
                                [bcMarginLeft]="1"
                                [bcMarginRight]="1"
                                [bcMarginBottom]="1"
                                [bcWidth]="1"
                                [bcHeight]="20"></common-barcode>
                    </div>

                    <div *ngIf="element.tag === 'location' && data.location">
                        Location: <b>{{ data.location }}</b>
                    </div>

                    <div *ngIf="element.tag === 'location_bc' && data.location">
                        <common-barcode
                                [bcValue]="data.location"
                                [bcDisplayValue]="false"
                                [bcMarginTop]="1"
                                [bcMarginLeft]="1"
                                [bcMarginRight]="1"
                                [bcMarginBottom]="1"
                                [bcWidth]="1"
                                [bcHeight]="20"></common-barcode>
                    </div>

                    <div *ngIf="element.tag === 'wh' && data.wh">
                        {{ data.wh }}
                    </div>

                    <div *ngIf="element.tag === 'hub' && data.hub">
                        {{ data.hub }}
                    </div>

                    <div *ngIf="element.tag === 'box_serial_list' && data.box_serial_list?.length">
                        <div><b>Box serials:</b></div>

                        <div *ngFor="let serial of data.box_serial_list">
                            <b>{{ serial }}</b>
                        </div>
                    </div>

                    <div *ngIf="element.tag === 'box_serial_list_bc' && data.box_serial_list_bc?.length">
                        <div><b>Box serials:</b></div>

                        <div *ngFor="let serial of data.box_serial_list_bc"
                             style="display:flex;
                         flex-wrap: wrap;
                         flex-direction: row;
                         justify-content: flex-start;
                         align-items: center;
                         align-content: stretch;
                         column-gap:10px;
                         margin-bottom: 10px">
                            <div style="flex-grow: 1">
                                <b>{{ serial }}</b>
                            </div>
                            <div>
                                <common-barcode
                                        [bcValue]="serial"
                                        [bcDisplayValue]="false"
                                        [bcMarginTop]="1"
                                        [bcMarginLeft]="1"
                                        [bcMarginRight]="1"
                                        [bcMarginBottom]="1"
                                        [bcWidth]="1"
                                        [bcHeight]="20"></common-barcode>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="element.tag === 'pallet_box_list' && data.pallet_box_list?.length">
                        <div><b>Pallet boxes:</b></div>

                        <div *ngFor="let box of data.pallet_box_list">
                            <b>{{ box }}</b>
                        </div>
                    </div>

                    <div *ngIf="element.tag === 'pallet_box_list_bc' && data.pallet_box_list_bc?.length">
                        <div><b>Pallet boxes:</b></div>

                        <div *ngFor="let box of data.pallet_box_list_bc"
                             style="display:flex;
                         flex-wrap: wrap;
                         flex-direction: row;
                         justify-content: flex-start;
                         align-items: center;
                         align-content: stretch;
                         column-gap:10px;
                         margin-bottom: 10px">
                            <div style="flex-grow: 1">
                                <b>{{ box }}</b>
                            </div>
                            <div>
                                <common-barcode
                                        [bcValue]="box"
                                        [bcDisplayValue]="false"
                                        [bcMarginTop]="1"
                                        [bcMarginLeft]="1"
                                        [bcMarginRight]="1"
                                        [bcMarginBottom]="1"
                                        [bcWidth]="1"
                                        [bcHeight]="20"></common-barcode>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
